import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'department';

const DepartmentService = {
  getList(regionIds = []) {
    const regionGetField =  ApiUtil.buildArrayToQueryString('regionId', regionIds);

    return Http.get(`/${RESOURCE_NAME}?${regionGetField}`);
  },
  getListByStudent(regionIds = []) {
    const regionGetField =  ApiUtil.buildArrayToQueryString('regionId', regionIds);

    return Http.get(`/${RESOURCE_NAME}/list?${regionGetField}`);
  },
};

export default DepartmentService;
